<template>
  <div class="TabTitle">
    <div class="TabTitle-inner">
      <div class="tab_control flex flex_jc_sb">
        <div
          class="tab_text flex_jc_center flex_ai_center"
          :class="rankClass === 2?'pitch_on':''"
          @click="rankClick('enterprise')"
        >优质工队</div>
        <div class="line"></div>
        <div
          class="tab_text flex_jc_center flex_ai_center"
          :class="rankClass === 1?'pitch_on':''"
          @click="rankClick('rentOut')"
        >优质人才</div>
        <div class="line"></div>
        <div
          class="tab_text flex_jc_center flex_ai_center"
          :class="rankClass === 4?'pitch_on':''"
          @click="rankClick('rotJobs')"
        >热门职位</div>
        <div class="line"></div>
        <div
          class="tab_text flex_jc_center flex_ai_center"
          :class="rankClass === 5?'pitch_on':''"
          @click="rankClick('recruitmentTeamList')"
        >招工队</div>
        <!-- <div class="tab_text flex_jc_center flex_ai_center"
             :class="rankClass === 3?'pitch_on':''"
        @click="rankClick('serviceCompany')">劳务公司</div>-->
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'TabTitle',
  components: {},
  data () {
    return {
      rankClass: 1
    }
  },
  computed: {},
  methods: {
    initData () {
      //
      if (this.$route.name === 'Talents') {
        this.rankClass = 1
      } else if (this.$route.name === 'Construction') {
        this.rankClass = 2
      } else if (this.$route.name === 'ServiceCompany') {
        this.rankClass = 3
      } else if (this.$route.name === 'hotJobsList') {
        this.rankClass = 4
      } else {
        this.rankClass = 5
      }
    },
    rankClick (val) {
      if (val === 'rentOut') {
        // this.rankClass = 1;
        this.$router.push({ path: '/talents' })
      } else if (val === 'enterprise') {
        // this.rankClass = 2;
        this.$router.push({ path: '/construction' })
      } else if (val === 'serviceCompany') {
        // this.rankClass = 3;
        this.$router.push({ path: '/serviceCompany' })
      } else if (val === 'rotJobs') {
        this.$router.push({ path: '/hotJobsList' })
      } else {
        this.$router.push({ path: '/recruitmentTeamList' })
      }
      // this.$emit('tabChange')
    }
  },
  watch: {},
  created () {},
  mounted () {
    this.initData()
  },
  updated () {
    this.initData()
  }
}
</script>

<style lang="scss" rel="stylesheet/scss" scoped>
@import "@/styles/variable.scss";
/* 面包屑 */
.TabTitle {
  width: 1200px;
  margin: 0 auto;
  overflow: hidden;
  .TabTitle-inner {
    background-color: #fff;
    border: 1px solid #e4e7ed;
    border-top-left-radius: 4px;
    border-top-right-radius: 4px;
    .tab_control {
      width: 324px;
      height: 55px;
      margin-left: 15px;
      background: #ffffff;
      box-sizing: border-box;
      line-height: 55px;
      font-size: 16px;
      .tab_text {
        width: 80px;
        color: #7f7f7f;
        cursor: pointer;
        border-bottom: 2px solid #fff;
      }
      .line {
        height: 24px;
        width: 1px;
        background: #dfe4ea;
        margin-top: 15px;
      }
    }
  }
  .pitch_on {
    font-weight: bold;
    color: #0286df !important;
    border-bottom: 2px solid #0286df !important;
  }
}
</style>
